'use strict';

exports.__esModule = true;
exports.FontIcon = undefined;

var _FontIcon2 = require('./FontIcon');

var _FontIcon3 = _interopRequireDefault(_FontIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon3.default;
exports.FontIcon = _FontIcon3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/FontIcons/index.js
// module id = 54
// module chunks = 168707334958949